import { FlowPage } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'

export const ParringIncompleteScreen = () => {
	const { t } = useTranslation()

	return (
		<FlowPage>
			<FlowPage.Content $isCentered>
				<FlowPage.Header title={t('parringScreen-incomplete-text')} />
			</FlowPage.Content>
		</FlowPage>
	)
}
